import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import type { ICellRendererAngularComp } from 'ag-grid-angular';
import type { ICellRendererParams } from 'ag-grid-community';

export interface AgreementActionRendererParams {
  envelopeId: string;
  signedStatus: string;
  isVoiding: boolean;
  hasDownloadableDocument: boolean;
  onSign: (envelopeId: string) => void;
  onVoid: (envelopeId: string) => void;
  onDownload: (envelopeId: string) => void;
}

@Component({
  selector: 'app-agreement-action-renderer',
  standalone: true,
  imports: [CommonModule, MatButtonModule, MatIconModule, MatTooltipModule],
  templateUrl: './agreement-action-renderer.component.html',
  styleUrl: './agreement-action-renderer.component.css'
})
export class AgreementActionRendererComponent implements ICellRendererAngularComp {
  isPending = false;
  isCompleted = false;
  isVoiding = false;
  hasDownloadableDocument = false;
  private envelopeId = '';
  private onSignFn: ((envelopeId: string) => void) | null = null;
  private onVoidFn: ((envelopeId: string) => void) | null = null;
  private onDownloadFn: ((envelopeId: string) => void) | null = null;

  agInit(params: ICellRendererParams): void {
    this.refresh(params);
  }

  refresh(params: ICellRendererParams): boolean {
    const p = params as unknown as AgreementActionRendererParams;
    this.envelopeId = p.envelopeId;
    this.isPending = p.signedStatus === 'sent' || p.signedStatus === 'delivered';
    this.isCompleted = p.signedStatus === 'completed';
    this.isVoiding = p.isVoiding ?? false;
    this.hasDownloadableDocument = p.hasDownloadableDocument;
    this.onSignFn = p.onSign ?? null;
    this.onVoidFn = p.onVoid ?? null;
    this.onDownloadFn = p.onDownload ?? null;
    return true;
  }

  onSign(): void {
    this.onSignFn?.(this.envelopeId);
  }

  onVoid(): void {
    this.onVoidFn?.(this.envelopeId);
  }

  onDownload(): void {
    this.onDownloadFn?.(this.envelopeId);
  }
}
